import { render } from "./ConfirmPage.vue?vue&type=template&id=390ba26e&scoped=true"
import script from "./ConfirmPage.vue?vue&type=script&lang=js"
export * from "./ConfirmPage.vue?vue&type=script&lang=js"

import "./ConfirmPage.vue?vue&type=style&index=0&id=390ba26e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-390ba26e"]])

export default __exports__